import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Svg } from './Svg';

export function YotpoStars({ rating = 0 }) {
  const stars = useMemo(() => {
    const fullStar = {
      key: 'star-full',
      label: 'Full Star',
    };
    const emptyStar = {
      key: 'star-empty',
      label: 'Empty Star',
    };
    const halfStar = {
      key: 'star-half-empty',
      label: 'Half Star',
    };

    return [...Array(5).keys()].map((index) => {
      const diff = rating - index;
      if (diff >= 0.75) {
        return fullStar;
      }
      if (diff >= 0.25) {
        return halfStar;
      }
      return emptyStar;
    });
  }, [rating]);

  return (
    <div className="flex items-center gap-0.5">
      {stars.map(({ key, label }, index) => (
        <span key={index}>
          <Svg
            className="w-4 text-currentcolor"
            src={`/icons/${key}.svg#${key}`}
            title={label}
            viewBox="0 0 24 24"
          />
        </span>
      ))}
    </div>
  );
}

YotpoStars.displayName = 'YotpoStars';
YotpoStars.propTypes = {
  color: PropTypes.string,
  rating: PropTypes.number,
};
